export const COMPLAINT_DETAIL_RESET = 'promotionDetailReset';

export default function complaintDetailReset() {
  return (dispatch) => {
    dispatch({
      type: COMPLAINT_DETAIL_RESET,
      payload: {},
    });
  };
}
